/* eslint-disable react/no-danger */
import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import MobileSplideCarousel from './MobileSplideCarousel';
import DesktopSplideCarousel from './DesktopSplideCarousel';

function FeaturesCarousel() {
  return (
    <Box
      tag="section"
      marginVertical={{ xs: '43px', lg: '80px' }}
    >
      <MobileSplideCarousel />
      <DesktopSplideCarousel />
    </Box>
  );
}

export default FeaturesCarousel;
